/*
 * @Author: 御坂网络服务 wangweigang@gooagoo.com
 * @Date: 2022-05-05 14:40:07
 * @LastEditors: Lsx
 * @LastEditTime: 2022-05-12 14:47:14
 * @FilePath: \parkinglot-web\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './util/vux'
import './util/cube-ui'
import util from './util/util'
// import util from './util/util'
import { request } from './util/request'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'assets/css/global.less'
Vue.use(Vant);
Vue.config.productionTip = false
import 'amfe-flexible/index.js'

Vue.prototype.$request = request
Vue.prototype.$util = util

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js